import * as tslib_1 from "tslib";
import * as moment from "moment";
import * as i0 from "@angular/core";
import * as i1 from "./self.scheduling.proxy";
/**
 ****************************************************************
 * Service class for self scheduling.
 *
 * Created by Shai Zelman on 06/02/2020.
 ****************************************************************
 */
var SelfSchedulingService = /** @class */ (function () {
    function SelfSchedulingService(selfSchedulingProxy) {
        this.selfSchedulingProxy = selfSchedulingProxy;
    }
    /**
     * Gets the list of orders and appointments for the patient.
     * @returns An HttpObservable with the list of appointments.
     */
    SelfSchedulingService.prototype.getOrdersAndAppointments = function () {
        return this.selfSchedulingProxy.getOrdersAndAppointments();
    };
    SelfSchedulingService.prototype.getAllSuggestionsForDay = function (sessionId, studies, orderKey, requestedProcedureId, startDate, endDate, orgStructureKeys, daysTimeOptions, searchesPerDay, opCodeKey, selectedResources) {
        if (selectedResources === void 0) { selectedResources = null; }
        var normalStartTime = new Date(startDate);
        normalStartTime.setMilliseconds(0);
        var normalEndTime = new Date(endDate);
        normalEndTime.setMilliseconds(0);
        return this.selfSchedulingProxy.getAllSuggestionsForDay(sessionId, studies, orderKey, requestedProcedureId, startDate, endDate, orgStructureKeys, this.normalizeDaysTimeOptions(daysTimeOptions), searchesPerDay, opCodeKey, selectedResources);
    };
    SelfSchedulingService.prototype.findAvailableDaysInRange = function (sessionId, studies, orderKey, requestedProcedureId, startDate, endDate, orgStructureKeys, daysTimeOptions, searchesPerDay, opCodeKey, selectedResources) {
        if (selectedResources === void 0) { selectedResources = null; }
        var normalStartTime = new Date(startDate);
        normalStartTime.setMilliseconds(0);
        var normalEndTime = new Date(endDate);
        normalEndTime.setMilliseconds(0);
        return this.selfSchedulingProxy.findAvailableDaysInRange(sessionId, studies, orderKey, requestedProcedureId, startDate, endDate, orgStructureKeys, this.normalizeDaysTimeOptions(daysTimeOptions), searchesPerDay, opCodeKey, selectedResources);
    };
    /**
     * Gets available time slots for the selected studies using the recommended results algorithm.
     * @param sessionId
     * @param studies
     * @param orderKey
     * @param requestedProcedureId
     * @param startDate
     * @param endDate
     * @param orgStructureKeys
     * @param daysTimeOptions
     * @param opCodeKey
     * @param selectedResources
     * @returns An HttpObservable containing the data.
     */
    SelfSchedulingService.prototype.getRecommendedTimeSlots = function (sessionId, studies, orderKey, requestedProcedureId, startDate, endDate, orgStructureKeys, daysTimeOptions, opCodeKey, selectedResources) {
        if (selectedResources === void 0) { selectedResources = null; }
        var normalStartTime = new Date(startDate);
        normalStartTime.setMilliseconds(0);
        var normalEndTime = new Date(endDate);
        normalEndTime.setMilliseconds(0);
        return this.selfSchedulingProxy.getRecommendedTimeSlots(sessionId, studies, orderKey, requestedProcedureId, startDate, endDate, orgStructureKeys, this.normalizeDaysTimeOptions(daysTimeOptions), opCodeKey, selectedResources);
    };
    /**
     * Gets a list of Modality Type Groups.
     * @returns An HttpObservable containing an array of Modality Type Groups.
     */
    SelfSchedulingService.prototype.getModalityTypeGroups = function () {
        return this.selfSchedulingProxy.getModalityTypeGroups();
    };
    /**
     * Gets a list of Holidays for a given month.
     * @returns An HttpObservable containing an array of Modality Type Groups.
     */
    SelfSchedulingService.prototype.getHolidaysForMonth = function (month) {
        return this.selfSchedulingProxy.getHolidaysForMonth(month);
    };
    SelfSchedulingService.prototype.getSpsCodesBySearchTerm = function (request) {
        return this.selfSchedulingProxy.getSpsCodesBySearchTerm(request);
    };
    SelfSchedulingService.prototype.getCommonExams = function (languageKey) {
        return this.selfSchedulingProxy.getCommonExams(languageKey);
    };
    SelfSchedulingService.prototype.getAllExams = function (languageKey) {
        return this.selfSchedulingProxy.getAllExams(languageKey);
    };
    SelfSchedulingService.prototype.checkCanNewOrderAndSchedule = function (request) {
        return this.selfSchedulingProxy.checkCanNewOrderAndSchedule(request);
    };
    SelfSchedulingService.prototype.getLocationSelectionData = function (request) {
        return this.selfSchedulingProxy.getLocationSelectionData(request);
    };
    SelfSchedulingService.prototype.getCancellationReasons = function (langKey) {
        return this.selfSchedulingProxy.getCancellationReasons(langKey);
    };
    SelfSchedulingService.prototype.cancelStudy = function (request) {
        return this.selfSchedulingProxy.cancelStudy(request);
    };
    SelfSchedulingService.prototype.scheduleStudies = function (scheduleData, selectedStudies, opCodeKey, orderKey) {
        if (orderKey === void 0) { orderKey = -1; }
        scheduleData.selectedScheduling = scheduleData.selectedScheduling.map(function (scheduleEntry) {
            var currentSelectedStudy = selectedStudies.find(function (selectedStudy) { return selectedStudy.spsCodeKey === scheduleEntry.SPS_Code_Key; });
            return tslib_1.__assign({}, scheduleEntry, { rpCodeKey: currentSelectedStudy.rpCodeKey, procedureCodeKeys: currentSelectedStudy.procedureKeys, selectedResourceAllocation: null });
        });
        return this.selfSchedulingProxy.scheduleStudies(scheduleData, opCodeKey, orderKey);
    };
    SelfSchedulingService.prototype.rescheduleStudies = function (scheduleData, selectedStudies, opCodeKey, orderKey) {
        if (orderKey === void 0) { orderKey = -1; }
        return this.selfSchedulingProxy.rescheduleStudies(scheduleData.map(function (scheduleEntry) {
            var currentSelectedStudy = selectedStudies.find(function (selectedStudy) { return selectedStudy.spsCodeKey === scheduleEntry.SPS_Code_Key; });
            return tslib_1.__assign({}, scheduleEntry, { rpCodeKey: currentSelectedStudy.rpCodeKey, selectedResourceAllocation: null });
        }), opCodeKey, orderKey);
    };
    SelfSchedulingService.prototype.scheduleStudiesWithModel = function (model) {
        return this.selfSchedulingProxy.scheduleStudiesWithModel(model);
    };
    SelfSchedulingService.prototype.announceScheduleChange = function (data) {
        return this.selfSchedulingProxy.announceScheduleChange(data);
    };
    SelfSchedulingService.prototype.normalizeDaysTimeOptions = function (daysTimeOptions) {
        return !daysTimeOptions ? null : {
            startTime: daysTimeOptions.startTime ? daysTimeOptions.startTime : moment().startOf("day").toDate(),
            endTime: daysTimeOptions.endTime ? daysTimeOptions.endTime : moment().endOf("day").toDate(),
            weekdays: daysTimeOptions.weekdays ? daysTimeOptions.weekdays : [true, true, true, true, true, true, true]
        };
    };
    SelfSchedulingService.prototype.GetContactInfoHtml = function (languageKey) {
        return this.selfSchedulingProxy.GetContactInfoHtml(languageKey);
    };
    SelfSchedulingService.prototype.GetOrgInstructionsHtml = function (request) {
        return this.selfSchedulingProxy.GetOrgInstructionsHtml(request);
    };
    SelfSchedulingService.prototype.GetSPSInstructionsHtml = function (request) {
        return this.selfSchedulingProxy.GetSPSInstructionsHtml(request);
    };
    SelfSchedulingService.prototype.CheckRowsExistForOpCodeKey = function (opCodeKey) {
        return this.selfSchedulingProxy.CheckRowsExistForOpCodeKey(opCodeKey);
    };
    SelfSchedulingService.prototype.GetSchedulingSearchInterval = function (orderKey, opCodeKey, selectedStudies) {
        return this.selfSchedulingProxy.GetSchedulingSearchInterval(orderKey, opCodeKey, selectedStudies);
    };
    SelfSchedulingService.prototype.logSessionError = function (opCodeKey, data) {
        return this.selfSchedulingProxy.logSessionError(opCodeKey, data);
    };
    SelfSchedulingService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SelfSchedulingService_Factory() { return new SelfSchedulingService(i0.ɵɵinject(i1.SelfSchedulingProxy)); }, token: SelfSchedulingService, providedIn: "root" });
    return SelfSchedulingService;
}());
export { SelfSchedulingService };
